module.exports = "<th>Тип недвижимости</th>\n<td>\n    <typeahead-with-tags\n            items=\"::terms.property_type\"\n            source=\"source.property_type\"\n            placeholder=\"Выберите тип\"\n    ></typeahead-with-tags>\n</td>"


//////////////////
// WEBPACK FOOTER
// ./src/components/advanced-browser/templates/sections/commercial/property_type.html
// module id = 337
// module chunks = 0